<div class="photo-container">
  @if(imageCompressionPipelineService.isLoadingImages()) {
    <p-message severity="info"
               data-testid="loading-images-message"
               class="loading-images-message">
      Adding {{ imageCompressionPipelineService.numberOfImagesBeingProcessed() }} images...
    </p-message>
  }
  @if(imageCompressionPipelineService.isCompressingImages()) {
    <p-message severity="info"
               data-testid="optimizing-images-message"
               class="optimizing-images-message">
      Optimizing {{ imageCompressionPipelineService.numberOfImagesBeingProcessed() }} images...
    </p-message>
  }
  <div class="photo-grid"
       (wheel)="onMediaGridWheel($event)"
       data-testid="issue-photo-grid">
    @for (image of galleryItems(); track $index) {
      <button class="photo-cell"
              type="button"
              (click)="onPhotoClicked($index)"
              [attr.data-testid]="'issue-photo-' + $index">
        <img [src]="image.imageData.azureBlobUri"
             alt="Image"
             data-testid="job-needs-attention-img" />
      </button>
    }
    <button class="photo-cell upload-placeholder"
            type="button"
            (click)="onUploadPhoto()"
            data-testid="upload-placeholder"
            role="button"
            [attr.aria-label]="'Upload image to issue'">
      <i class="pi pi-upload"
         aria-hidden="true"></i>
      <span>Upload Image</span>
    </button>
  </div>
</div>

<input #fileInput
       type="file"
       accept="image/*"
       multiple
       (change)="handleFiles($event)"
       style="display: none;"
       data-testid="file-input">